'use es6';

import GraderAPI from '../api/GraderAPI';
import { ActionTypes } from '../constants/AppConstants';
import { ERROR } from '../constants/Paths';
import history, { replace } from '../util/History';
import { matchPath } from 'react-router-dom';
import contactTracker from '../lib/contactTracker';
import { getEmail } from '../selectors/Contact';
var graderAPI = new GraderAPI(); // check if we are in a widget route, and then add the part of path.

var matchReplace = function matchReplace() {
  var match = matchPath(history.location.pathname, {
    path: '/widget',
    exact: false,
    strict: false
  });

  if (match) {
    return replace("/widget" + (arguments.length <= 0 ? undefined : arguments[0]));
  }

  return replace.apply(void 0, arguments);
};

export default {
  getGrade: function getGrade(websiteUrl) {
    var _this = this;

    return function (dispatch, getState) {
      var email = getEmail(getState());
      dispatch({
        type: ActionTypes.GRADE_WEBSITE_POLLING,
        payload: {
          websiteUrl: websiteUrl
        }
      });
      graderAPI.get(websiteUrl).then(function (response) {
        if (response.status === 200) {
          var websiteGrade = response.responseJSON;
          dispatch({
            type: ActionTypes.WEBSITE_GRADED,
            payload: websiteGrade
          });

          if (email) {
            contactTracker.saveContact(email, websiteGrade);
          }
        }
      }, function (response) {
        if (response.status === 404) {
          dispatch(_this.gradeWebsite(websiteUrl));
        } else {
          var errorType = response.responseJSON.errorType;
          dispatch({
            type: ActionTypes.WEBSITE_GRADED_ERROR,
            payload: {
              websiteUrl: websiteUrl,
              errorType: errorType
            }
          });
          matchReplace(ERROR + "/" + errorType);
        }
      });
    };
  },
  gradeWebsite: function gradeWebsite(websiteUrl) {
    return function (dispatch) {
      dispatch({
        type: ActionTypes.GRADE_WEBSITE,
        payload: {
          websiteUrl: websiteUrl
        }
      });
      graderAPI.post(websiteUrl).then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          dispatch({
            type: ActionTypes.GRADE_WEBSITE_POLLING
          });
        }
      }, function () {
        dispatch({
          type: ActionTypes.WEBSITE_GRADED_ERROR,
          payload: {
            websiteUrl: websiteUrl
          }
        });
        matchReplace(ERROR);
      });
    };
  },
  storeContact: function storeContact(contactEmail) {
    return function (dispatch) {
      dispatch({
        type: ActionTypes.STORE_CONTACT,
        payload: {
          contactEmail: contactEmail
        }
      });
    };
  },
  resultsPageUnmounted: function resultsPageUnmounted() {
    return {
      type: ActionTypes.RESULTS_PAGE_UNMOUNTED
    };
  }
};